export const EXPIRATION_FOR_CACHE = 7;
export const EXPIRATION_FOR_DIGITAL_OCEAN = '+7 day';
